/* global bootstrap */
const OFFCANVAS_ID = '#offcanvasSearch'
const TOGGLE_SELECTOR = `[data-bs-target="${OFFCANVAS_ID}"]`

const getOffcanvasSearchElements = () => {
  const el = document.querySelector(OFFCANVAS_ID)
  return {
    el,
    instance: el ? bootstrap.Offcanvas.getOrCreateInstance(el) : null,
    toggleButtons: document.querySelectorAll(TOGGLE_SELECTOR)
  }
}

export const OffcanvasSearchClickAway = () => {
  const { el, instance, toggleButtons } = getOffcanvasSearchElements()
  if (!el || !instance) return

  document.addEventListener('click', (event) => {
    const isClickInside = el.contains(event.target)
    const isToggleButton = event.target.closest('[data-bs-toggle="offcanvas"]')

    if (instance._isShown && !isClickInside && !isToggleButton) {
      instance.hide()
      toggleButtons.forEach((btn) => btn.removeAttribute('data-open'))
    }
  })
}
